import { render } from "./DatastoreApiKeys.vue?vue&type=template&id=55aff218&scoped=true"
import script from "./DatastoreApiKeys.vue?vue&type=script&lang=js"
export * from "./DatastoreApiKeys.vue?vue&type=script&lang=js"

import "./DatastoreApiKeys.vue?vue&type=style&index=0&id=55aff218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aff218"]])

export default __exports__